export enum FlowState {
    RUNNING = "running",
    COMPLETE = "complete",
    CANCELED = "canceled",
    ERROR = "error",
}
